export default __webpack_public_path__ + "622ef605adecb6f55835f5d48b0048a8.mp3";